// choices/styleChoices.js
import { images } from "../../components/utility/imageImports";

const styleChoicesRo = (room) => [
  {
    label: "Industrial",
    value: "industrial",
    imageUrl: images[`industrial/${room}/forForm.jpg`],
  },

  {
    label: "Scandinav",
    value: "scandinavian",
    imageUrl: images[`scandinavian/${room}/forForm.jpg`],
  },

  {
    label: "Mediteranean",
    value: "mediterranean",
    imageUrl: images[`mediterranean/${room}/forForm.jpg`],
  },

  {
    label: "Cicladic",
    value: "cycladic",
    imageUrl: images[`cycladic/${room}/forForm.jpg`],
  },

  {
    label: "Neoclasic",
    value: "neoclassical",
    imageUrl: images[`neoclassical/${room}/forForm.jpg`],
  },

  {
    label: "Minimalist",
    value: "minimal",
    imageUrl: images[`minimal/${room}/forForm.jpg`],
  },
  {
    label: "Modern",
    value: "modern",
    imageUrl: images[`modern/${room}/forForm.jpg`],
  },
  {
    label: "Boho",
    value: "boho",
    imageUrl: images[`boho/${room}/forForm.jpg`],
  },
  {
    label: "Vintage",
    value: "vintage",
    imageUrl: images[`vintage/${room}/forForm.jpg`],
  },
  {
    label: "Pop",
    value: "pop",
    imageUrl: images[`pop/${room}/forForm.jpg`],
  },
];

export default styleChoicesRo;
